// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions"; 

const firebaseConfig = {
  apiKey: "AIzaSyCn-KL6FVJSt5NXn92wkQj8sP5F2ytgYaA",
  authDomain: "spot-your-leads-db.firebaseapp.com",
  projectId: "spot-your-leads-db",
  storageBucket: "spot-your-leads-db.firebasestorage.app",
  messagingSenderId: "713027409074",
  appId: "1:713027409074:web:747b61f8d8385af9fbe5ab"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app); 
const storage = getStorage(app);
const functions = getFunctions(app); 

export { auth, db, app , storage , functions}; // Export Firestore